/// <reference path="../typings/index.d.ts" />

namespace App.Docs {
    export class MobileNav {
        public static inicializar(): void {
            $(document).on('click', '[data-docs-menu]', function () {
                $('[data-docs-sidebar]').addClass('is-open');
                $('.docs-mobile-backdrop').addClass('is-open');
            });

            $(document).on('click', '[data-docs-close]', function () {
                MobileNav.fechar();
            });

            $(document).on('keyup', function (event: JQueryEventObject) {
                if (event.key === 'Escape') {
                    MobileNav.fechar();
                }
            });
        }

        private static fechar(): void {
            $('[data-docs-sidebar]').removeClass('is-open');
            $('.docs-mobile-backdrop').removeClass('is-open');
        }
    }
}

$(document).ready(function () {
    if ($('[data-docs-menu]').length) {
        App.Docs.MobileNav.inicializar();
    }

    App.Docs.UserMenu.inicializar();
});
